import Section from "../Section";

export default class Cart extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    // Quantity updates are now handled by the cart-items web component
    // using Shopify's section rendering API
  }
}
